import { createRequestStore } from '@rst/libs-ts'
import { RenderBlock } from '@rst/render-blocks/src/types'
import { withBaseSiteUrl } from '../lib/with-url'
import { combine } from 'effector'
import { $locale } from './init'

const { fx, $combined: $nav } = createRequestStore<
	void,
	{ lang?: string },
	RenderBlock.NavigationItem[]
>(
	{
		url: withBaseSiteUrl('/api/nav'),
		params: combine({ lang: $locale }, ({ lang }) =>
			lang === 'ru' ? {} : { lang }
		),
	},
	window.__nav__ || null
)

if (!window.__nav__) {
	fx()
}

export { $nav }
